import { configureStore } from "@reduxjs/toolkit";

import appReducer from "@/store/app/appSlice";
import authReducer from "@/store/auth/authSlice";
import socketReducer from "@/store/socket/socketSlice";
import themeReducer from "@/store/theme/themeSlice";

/**
 * Per docs/architecture/frontend-architecture.md, Redux holds only genuinely
 * global, cross-feature state — everything else is server state (TanStack
 * Query) or component-local state. Four slices, one per domain folder:
 *
 * - `theme` — the only one with a real consumer today (`useTheme`,
 *   `ThemeProvider`).
 * - `auth` — reducers are complete and correct; nothing dispatches into them
 *   yet (no login flow exists). Populated once the identity feature lands.
 * - `app` — currently just `isOnline`; see appSlice.ts for why that's the
 *   one piece of state justified without a feature behind it.
 * - `socket` — connection-status tracking; populated once the messaging
 *   feature's socket client exists.
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    app: appReducer,
    socket: socketReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
